export default __webpack_public_path__ + "static/media/donation.1224f83c.jpg";